module.exports = __webpack_public_path__ + "img/czjyZlys.608732d2.png";